
/* eslint-disable react/react-in-jsx-scope,react/display-name,react/jsx-no-undef,keyword-spacing */
import Zergling from '../helpers/zergling';
import { ClosePopup, OpenPopup } from "../actions/ui";
import { TerminalError, TicketIn, LoyalCard, AdminUserCommands } from "../actions/terminal";
import Config from '../config/main';
import { t } from "./translator";
import { addEventCompareConflicts } from './sport/betslip';
import { store } from '../index/terminalApp';
import { BetStateEnum } from '../constants/enums/betState';
import { fetchRequest } from './util/requestMiddleware';
import { BetslipSetType } from '../actions/betslip';

export const getTicketState = ({ bet_state_id, dataFromCasino, dataFromSwarm }) => {
    if (bet_state_id === BetStateEnum.Rejected)
        return BetStateEnum.Rejected;

    if (bet_state_id === BetStateEnum.CashOut)
        return BetStateEnum.CashOut;

    if (bet_state_id === BetStateEnum.Returned || dataFromCasino?.IsRollbacked)
        return BetStateEnum.Returned;

    if (bet_state_id === BetStateEnum.Lost || (dataFromSwarm && !dataFromSwarm.WinAmount && dataFromCasino?.Settled))
        return BetStateEnum.Lost;
        
    if (bet_state_id === BetStateEnum.Won || (dataFromSwarm?.WinAmount > 0 && !dataFromCasino?.IsRollbacked))
        return BetStateEnum.Won;

    if (dataFromSwarm && dataFromSwarm.WinAmount === dataFromSwarm.Amount)
        return BetStateEnum.Rollbacked; //TODO review after backend/casino Rollbacked state right implementation
        
    return BetStateEnum.Accepted;
}

export const ticketHasTax = ticketInfo => {
    const statesWithoutTax = [BetStateEnum.Returned, BetStateEnum.Rollbacked];
    return !statesWithoutTax.includes(getTicketState(ticketInfo));
}

export const getCasinoTicketItemState = betInfo => {
    if (betInfo.win_info?.WinAmount > 0)
        return BetStateEnum.Won;

    if (betInfo.win_info && !betInfo.win_info.WinAmount)
        return BetStateEnum.Lost;

    return BetStateEnum.Accepted;
}

export const getCasinoBetsInfo = async transIds => fetchRequest(
    Config.casino.middlewareUrl,
    `api/tickets/GetTicketInfoByTransactionIdsTokenAuth?token=${Config.casino.middlewareAuthToken}`,
    'POST',
    { body: transIds },
);

export const processBarcode = (result) => {
    const state = store.getState();

    if (typeof result !== 'string') result = result.toString();

    if (result === "" || state.superbetInProcess) {
        window.barcodeBuffer = [];
        return;
    }

    if (state.terminal.isLoyalCardInputActive) {
        if (result.length < 9) {
            let loyalCardResult = state;
            if (!loyalCardResult.terminal.loyalCard || !loyalCardResult.terminal.loyalCard.result) {
                store.dispatch(LoyalCard({ result }));
            }
            window.barcodeBuffer = [];
            store.dispatch(ClosePopup())
            return;
        }
    }

    if (result[0] === '6' && result.length === 13) {
        return store.dispatch(AdminUserCommands('checkByBarcode', {
            id: result
        }))
    }

    if (Config.enableMultipleWinsPopup && isMultpleTicketsPopupOpen()) {
        const { tickets } = state.uiState;
        if (!tickets[result] && Object.keys(tickets).length >= Config.multipleWinsMaxTicketsCount)
            return throwTicketError(t("You can scan maximum {1} bets", Config.multipleWinsMaxTicketsCount));
    }

    //Casino ticket in
    let transId;
    let isCasinoBet = false;

    // if (barcodeResult.data.error) {
    // store.dispatch(TerminalError(barcodeResult.data));

    if (isCasinoTicket(result)) {
        transId = parseInt(result.slice(1, result.length));
        isCasinoBet = true;
    }
    if (isCasinoBet) {
        Zergling.get({
            ExternalId: transId,
            token: JSON.parse(sessionStorage.getItem("authData")).token
        }, 'terminal_get_casino_bets').then(data => {
            if (data.HasError) {
                throwTicketError(data.StatusCode);
            } else if (data.Data.length !== 0) {
                if (data.Data[0].PaidCashDeskId !== null) {
                    throwTicketError('This ticket is already paid');
                    return;
                }
                const dataFromSwarm = data.Data[0];
                let popupName = 'ticket-in',
                    popupData = { dataFromCasino: {}, dataFromSwarm }

                if (Config.enableMultipleWinsPopup) {
                    popupName = 'multipleTicketsPopup'
                    popupData = {
                        data: {
                            ...popupData,
                            success: true,
                            casinoTicket: true,
                            casino_barcode: result,
                            barcode: Number(dataFromSwarm.ExternalId),
                            amount: dataFromSwarm.Amount
                        }
                    }
                }
                const showErrorPopup = () => {
                    store.dispatch(OpenPopup(popupName, { ...popupData, data: { ...popupData.data, success: false } }))
                }
                getCasinoBetsInfo([transId]).then(res => {
                    if (res?.Success) {
                        const dataFromCasino = res.Data[0];

                        dataFromCasino?.BetMultiplyInfo.forEach(item => {
                            item.win_info = dataFromCasino.WinMultiplyInfo?.find(winInfo => (
                                item.AdditionalInfo?.betWinLinkId === winInfo.AdditionalInfo?.betWinLinkId
                            ))
                        });

                        Config.enableMultipleWinsPopup
                            ? popupData.data.dataFromCasino = dataFromCasino
                            : popupData.dataFromCasino = dataFromCasino,

                            store.dispatch(OpenPopup(popupName, popupData));
                    } else {
                        showErrorPopup()
                    }
                }).catch(() => {
                    showErrorPopup()
                })
            } else {
                throwTicketError('Bet not found');
            }
        })
        window.barcodeBuffer = [];
        return;
    }
    // if (result.length < 16) {
    //     result = result.slice(0, 14);
    // } else {
    //     result = result.slice(0, 13);
    // }
    if (isNaN(result)) {
        throwTicketError('Bet not found');
        window.barcodeBuffer = [];
        return;
    }

    if (result.length <= 9) {
        let apiUrl
        const params = {}

        if (Config.main.useBetBookLastApi) {
            params.id = +result
            params.token = 'lmG9Ag=='
            apiUrl = 'terminal_get_bet_by_bet_book_id_v2'
        } else {
            params.id = +result
            apiUrl = 'terminal_get_bet_by_bet_book_id'
            params.token = JSON.parse(sessionStorage.getItem("authData")).token
        }

        (Zergling.get(params, apiUrl)).then(data => {
            bookIdCheck(data)();
        });
        window.barcodeBuffer = [];
        return;
    }

    let promiseOfQuery;

    result = result.replace(/^\s+|\s+$/g, '');

    function bookIdCheck(data) {
        const command = (selections, games) => ({
            source: "betting",
            what: {
                sport: ['id', 'alias'],
                region: ['id'],
                competition: ['id'],
                game: [],
                market: [],
                event: ["id", "order", "name", "price", "type", "base"]
            },
            where: {
                game: { id: { "@in": games } },
                event: { id: { "@in": selections } }
            }
        });
        const addToBetslip = (fullselectionsTree) => {
            Object.keys(fullselectionsTree.sport).filter(item => Object.prototype.hasOwnProperty.call(fullselectionsTree.sport, item)).map(item => {
                const sport = fullselectionsTree.sport[item];
                Object.keys(sport.region).filter(item => Object.prototype.hasOwnProperty.call(sport.region, item)).map(item => {
                    const region = sport.region[item];
                    Object.keys(region.competition).filter(item => Object.prototype.hasOwnProperty.call(region.competition, item)).map(item => {
                        const competition = region.competition[item];
                        Object.keys(competition.game).filter(item => Object.prototype.hasOwnProperty.call(competition.game, item)).map(item => {
                            const game = competition.game[item];
                            Object.keys(game.market).filter(item => Object.prototype.hasOwnProperty.call(game.market, item)).map(item => {
                                const market = game.market[item];
                                Object.keys(market.event).filter(item => Object.prototype.hasOwnProperty.call(market.event, item)).map(item => {
                                    const event = market.event[item];
                                    store.dispatch(addEventCompareConflicts({
                                        ...game,
                                        alias: sport.alias,
                                        regionId: region.id,
                                        competitionId: competition.id
                                    }, market, event, event.id));
                                });
                            });
                        });
                    });
                });
            });
        }
        return async () => {
            // TODO create jeneric functionality
            let eventIds, matchIds, fullselectionsTree, activeBet
            if (Config.main.useBetBookLastApi) {
                if (!data.data.bets) {
                    throwTicketError('Wrong booking code, please try again');
                    window.barcodeBuffer = [];
                    return;
                }
                activeBet = data.data.bets[0]
                eventIds = activeBet.Selections.map(item => item.SelectionId);
                matchIds = activeBet.Selections.map(item => item.MatchId);
                fullselectionsTree = (await Zergling.get(command(eventIds, matchIds))).data;
            }
            if (!Config.main.useBetBookLastApi) {
                if (!data.data.selectionIds) {
                    throwTicketError('Wrong booking code, please try again');
                    window.barcodeBuffer = [];
                    return;
                }
                eventIds = data.data.selectionIds.map(item => item);
                matchIds = data.data.MatchIds.map(item => item);
                fullselectionsTree = (await Zergling.get(command(eventIds, matchIds))).data;
            }

            addToBetslip(fullselectionsTree)
            Config.main.useBetBookLastApi && store.dispatch(BetslipSetType(activeBet.BetType))
        }
    }

    var fullTicket;
    if (result.length === 20 && result[0] === "1") {
        fullTicket = result;
        result = result.slice(1, result.length);
        result = result.slice(0, result.length - 7);
        result = Number(result);

        // TODO make request for only betId now it is betId + 0
        result = result * 10;
    }
    // TODO With Khikar
    if ((result.length === 12 || result.length === 13 || result.length === 11) && Config.oldTicketsRestriction) {
        return store.dispatch(OpenPopup("errorPopup", { errorMessage: 'Wrong Ticket.' }));
    }
    result = String(result);
    let command = 'check_terminal_bet_ticket';
    let str = String(parseInt(result));
    let params = {
        'bar_code': result,
        'is_with_cashout': true,
        'token': state.terminal?.authData.token
    };
    if (isCashOutTicket(str)) {
        command = 'check_terminal_tito_document';
        delete params.bar_code;
        delete params.is_with_cashout;
        
        if(result.slice(0,2)=="99" || result.slice(0,2)=="98"){
            params.doc_id = parseInt(result.slice(1, result.length - 1));
        } else{        
            params.doc_id = parseInt(result.slice(1, result.length));
        }
    }   
    promiseOfQuery = Zergling.get(params, command);

    promiseOfQuery.then((data) => {
        console.log(barcodeResult, 'barcodeResult', data);
        let barcodeResult = getBarcodeResultForSpring(data, str, fullTicket);
        if (barcodeResult.data) {
            if (barcodeResult.data.error) {
                if (Config.enableMultipleWinsPopup) {
                    store.dispatch(OpenPopup('multipleTicketsPopup', barcodeResult));
                    window.barcodeBuffer = [];
                    return;
                } else {
                    throwTicketError(barcodeResult.data);
                    window.barcodeBuffer = [];
                    return;
                }
            } else {
                // enableMultipleWinsPopup
                if (!barcodeResult.data.cashout && !Config.enableMultipleWinsPopup) {
                    store.dispatch(TicketIn(barcodeResult));
                } else if (!barcodeResult.data.cashout && Config.enableMultipleWinsPopup) {
                    store.dispatch(OpenPopup('multipleTicketsPopup', barcodeResult));
                } else {
                    if (Config.enableMultipleWinsPopup) {
                        store.dispatch(OpenPopup('multipleTicketsPopup', barcodeResult));
                    } else {
                        store.dispatch(OpenPopup('cashin', { data: barcodeResult }));
                    }
                }
            }
        }
        window.barcodeBuffer = [];
    }).catch(() => {
        window.barcodeBuffer = [];
    });

    let enableTitoArgs = (details) => {
        return details ? details.bo_payment || +details.amount > 0 : null; //if it is cashout ticket or bet ticket that has WinAmount
    };

    const getStatusText = (amount, status) => {
        let currency = JSON.parse(sessionStorage.getItem("authData")).currency,
            symbol = Config.main.currency[currency],
            /*TODO add getStatusText in variable*/
            statusTexts = {
                1: "Your bet is still pending. Please try again later.",
                3: "Unlucky! Your bet is lost.",
                2: function () {
                    return (t("Your bet has been canceled. Returned amount is") + " " + (Config.useCurrencySymbol ? symbol + amount : `${amount} ${currency}`));
                },
                4: function () {
                    return (t("Well done! You’ve just won") + " " + (Config.useCurrencySymbol ? symbol + amount : `${amount} ${currency}`));
                },
                5: function () {
                    return (t("Bet has been cashouted. Return amount is") + " " + (Config.useCurrencySymbol ? symbol + amount : `${amount} ${currency}`));
                },
                "cashout": function () {
                    return (t("Your Cashout amount is ") + symbol + amount);
                }
            };
        return (typeof statusTexts[status] === "function") ? statusTexts[status]() : statusTexts[status];
    };

    let getBarcodeResultForSpring = (details, barcode, fullTicket) => {
        let data, ticketError;

        let ticketErrMap = (error, paidDate) => {
            let map = {
                "TerminalTicketAlreadyPaid": "Voucher is already exchanged",
                "TerminalTicketNotFound": "Terminal ticket not found",
                "BetNotFoundError": "Bet not found",
                "alreadyPaid": "This ticket is already paid",
                "The bet is not found": "Bet not found",
                "WrongInputParameters": "Wrong input parameters",
                "NotAuthorized": "Terminal ticket not found",
                "InternalError": "Bet not found",
                "Client currency mismatch": "Bet not found",
                "Error processing your request": "Bet not found",
                "PartnerMismatch": "Bet not found",
                "Not allowed": "The bet was placed in another location"
            };

            if (paidDate) {
                return t(map["alreadyPaid"]);
            }
            return t(map[error]);
        };

        if (isCashOutTicket(barcode)) {
            ticketError = ticketErrMap(details.data) || (details.status_code !== 0 && details.data);
            if (ticketError) {
                data = {
                    cashout: true,
                    error: details.status_code ? details.status_code : details.code,
                    errorText: ticketError
                };
            } else {
                data = {
                    cashout: true,
                    bo_payment: true,
                    amount: details.data.amount,
                    barcode: details.data.document_id,
                    created: details.data.date,
                    // status: ticketErrMap(details.status_code),
                    status: ticketErrMap(details.status_code),
                    data: ticketErrMap(details.data)
                };
            }
        } else {
            ticketError = ticketErrMap(details.data, details.data.paid_date) || (details.status_code !== 0 && details.data);
            if (ticketError) {
                data = {
                    cashout: false,
                    error: details.data.paid_date ? 1 : details.status_code ? details.status_code : details.code,
                    errorText: ticketError
                };
            } else {
                let estimatedReturns = details.data.possible_win;//details.data.tax_amount ? (details.data.possible_win - details.data.tax_amount).toFixed(2) : details.data.possible_win;
                if (details.data.win_amount || (details.data.state_id === 4 || details.data.state_id === 5)) {
                    estimatedReturns = details.data.tax_amount ? (details.data.win_amount - details.data.tax_amount).toFixed(2) : details.data.win_amount;
                } else {
                    estimatedReturns = details.data.possible_tax_amount ? (details.data.possible_win - details.data.possible_tax_amount).toFixed(2) : details.data.possible_win;
                }
                
                data = {
                    cashout: false,
                    bo_payment: false,
                    amount: details.data.win_amount,
                    betAmount: details.data.amount,
                    betshop_id: details.data.betshop_id,
                    possibleWin: details.data.possible_win,
                    possible_tax_amount: details.data.possible_tax_amount,
                    tax_amount: details.data.tax_amount,
                    price: details.data.price,
                    sportBet: true,
                    system_min_count: details.data.system_min_count,
                    selectionCount: details.data.selection_list?.length || 1,
                    created: details.data.created,
                    betType: details.data.type_name,
                    betTypeId: details.data.type_id,
                    bet_state_id: details.data.state_id,
                    bet_state_name: details.data.state_name,
                    win_amount: details.data.win_amount,
                    barcode: fullTicket || details.data.bar_code || details.data.barcode,
                    status: details.data.state_id,
                    cashout_amount: details.data.cashout_amount,
                    paid_date: details.data.paid_date,
                    predefined_multiple_id: details.data.predefined_multiple_id,
                    betBuilderDetails: details.data.bet_details?.description,
                    competitionName: details.data.bet_details?.league_name,
                    events: {
                        event: ((events) => {
                            let evs = [];
                            for (let key in events) {
                                if (events.hasOwnProperty(key)) {
                                    let e = events[key];
                                    e.__index__ = key;
                                    e.coeficient = e.price;
                                    e.game_name = e.match_name;
                                    e.start_date_time = e.start_time;
                                    e.event_name = e.display_market_name + "-" + e.display_selection_name;
                                    e.outcome = e.state;
                                    evs.push(e);
                                }
                            }
                            return evs;
                        })(details.data.selection_list)
                    },
                    statusText: getStatusText(estimatedReturns, details.data.state_id)
                };
            }
        }
        return {
            data,
            enableTitoArgs: enableTitoArgs(data)
        };
    };
};

const throwTicketError = (text) => {
    isMultpleTicketsPopupOpen()
        ? store.dispatch(OpenPopup('multipleTicketsPopup', { data: { error: true, errorText: t(text) } }))
        : store.dispatch(TerminalError(t(text)));
}

const isMultpleTicketsPopupOpen = () => store.getState().uiState.popup === 'multipleTicketsPopup';

const isCashOutTicket = str => str.length > 12 && str.charAt(0) === '9';
const isCasinoTicket = str => str.length > 13 && str.charAt(0) === '2';
